import {
  availableCountry,
  Country,
  Locale,
} from '../../navigation/types/config-base';

export function mapLocaleToCountry(locale: Locale): Country {
  const parts = locale.split(`-`);
  const country = parts[1] as Country;
  if (availableCountry.length > 0 && availableCountry.includes(country)) {
    return country;
  }
  // Return first available country as fallback instead of hardcoded 'US'
  return availableCountry[0] as Country;
}
